import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import toast from "react-hot-toast";

const Account = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [formData, setFormData] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    const isLoggedIn = sessionStorage.getItem("isLoggedIn");
    if (isLoggedIn === "true" && !location.state?.fromCart) {
      toast.success("You're already logged in!");
      navigate("/");
    }
  }, [navigate, location.state]);

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.id]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.email || !formData.password) {
      toast.error("Please fill in all fields");
      return;
    }

    sessionStorage.setItem("isLoggedIn", "true");
    sessionStorage.setItem("userEmail", formData.email);
    window.dispatchEvent(new Event("sessionUpdated"));

    toast.success("Welcome back!");
    setTimeout(() => navigate("/"), 900);
  };

  return (
    <section className="sx-login">
      <div className="sx-login-box">
        <h2>Sign in to Awaneez</h2>
        <p className="sx-sub">Access your account & manage orders</p>

        <form onSubmit={handleSubmit}>
          {/* Email */}
          <div className="sx-field">
            <label>Email address</label>
            <input
              id="email"
              type="email"
              placeholder="you@example.com"
              value={formData.email}
              onChange={handleChange}
            />
          </div>

          {/* Password */}
          <div className="sx-field sx-password">
            <label>Password</label>
            <input
              id="password"
              type={showPassword ? "text" : "password"}
              placeholder="Enter password"
              value={formData.password}
              onChange={handleChange}
            />
            <span onClick={() => setShowPassword(!showPassword)}>
              <i className={`ph ${showPassword ? "ph-eye" : "ph-eye-slash"}`} />
            </span>
          </div>

          <button type="submit" className="sx-btn">
            Sign In
          </button>
        </form>

        <p className="sx-footers">
          Don’t have an account?
          <Link to="/register"> Create one</Link>
        </p>
      </div>

      {/* CSS */}
      <style>{`
        .sx-login {
          min-height: 90vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f4f6fb;
          padding: 30px 16px;
        }

        .sx-login-box {
          background: #fff;
          width: 100%;
          max-width: 460px;
          padding: 40px;
          border: 1px solid #e5e7eb;
        }

        .sx-logo {
          text-align: center;
          margin-bottom: 20px;
        }

        .sx-logo img {
          width: 150px;
        }

        .sx-login-box h2 {
          text-align: center;
          font-size: 24px;
          margin-bottom: 6px;
          color: #111;
        }

        .sx-sub {
          text-align: center;
          color: #666;
          font-size: 14px;
          margin-bottom: 30px;
        }

        .sx-field {
          margin-bottom: 18px;
        }

        .sx-field label {
          display: block;
          font-size: 13px;
          font-weight: 600;
          margin-bottom: 6px;
          color: #333;
        }

        .sx-field input {
          width: 100%;
          height: 46px;
          padding: 0 14px;
          border: 1px solid #d1d5db;
          font-size: 14px;
          outline: none;
        }

        .sx-field input:focus {
          border-color: #2563eb;
        }

        .sx-password {
          position: relative;
        }

        .sx-password span {
          position: absolute;
          right: 14px;
          top: 38px;
          cursor: pointer;
          color: #555;
          font-size: 18px;
        }

        .sx-btn {
          width: 100%;
          height: 48px;
          background: #111;
          color: #fff;
          font-weight: 600;
          border: none;
          cursor: pointer;
          margin-top: 8px;
          transition: 0.3s;
        }

        .sx-btn:hover {
          background: #2563eb;
        }

        .sx-footers {
          text-align: center;
          margin-top: 18px;
          font-size: 14px;
          color: #555;
        }

        .sx-footers a {
          color: #2563eb;
          margin-left: 6px;
          font-weight: 600;
          text-decoration: none;
        }
      `}</style>
    </section>
  );
};

export default Account;
